import React from 'react';

interface CustomCheckboxProps {
  checked: boolean;
  onChange: () => void;
  ariaLabel?: string;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
}

// Modern custom checkbox with enhanced styling and animations
const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange, ariaLabel, size = 'md', disabled = false }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const iconSizes = {
    sm: 14,
    md: 16,
    lg: 18
  };

  return (
    <label className={`inline-flex items-center justify-center cursor-pointer select-none group ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}>
      <input
        type="checkbox"
        aria-label={ariaLabel}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="sr-only peer"
      />
      <div className={`
        ${sizeClasses[size]}
        relative
        rounded-lg
        border-2
        transition-all
        duration-200
        ease-out
        flex
        items-center
        justify-center
        shadow-sm
        ${checked 
          ? 'bg-gradient-to-br from-blue-500 to-blue-600 border-blue-500 shadow-blue-200' 
          : 'bg-white border-gray-300 hover:border-gray-400 hover:shadow-md'
        }
        ${!disabled && 'group-hover:scale-105 group-active:scale-95'}
        dark:${checked 
          ? 'bg-gradient-to-br from-blue-600 to-blue-700 border-blue-600 shadow-blue-900/20' 
          : 'bg-gray-800 border-gray-600 hover:border-gray-500'
        }
      `}>
        <i
          className={`
            ri-check-line 
            text-white 
            transition-all 
            duration-200 
            ease-out
            ${checked ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}
          `}
          style={{ fontSize: `${iconSizes[size]}px` }}
        />
        {/* Ripple effect overlay */}
        <div className={`
          absolute inset-0 rounded-lg opacity-0 
          ${!disabled && 'group-active:opacity-20'} 
          bg-black transition-opacity duration-150
        `} />
      </div>
    </label>
  );
};
export default CustomCheckbox;